import { Trans } from "react-i18next";

import type { NotificationContentProps } from "../../types";

export default function AiIdeaAnonymityCheckContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey={
        status === "success" ? "notifications.aiIdeaAnonymityCheckSuccess"
        : status === "pending" ?
          "notifications.aiIdeaAnonymityCheck"
        : "notifications.aiIdeaAnonymityCheckFailed"
      }
      values={{ idea: ownerIdea?.name || "Deleted" }}
    />
  );
}
